module.exports = __webpack_public_path__ + "img/communication_is_aid.e577ae63.png";